import script from "./LoadingWheel.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingWheel.vue?vue&type=script&setup=true&lang=js"

import "./LoadingWheel.vue?vue&type=style&index=0&id=bad63706&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bad63706"]])

export default __exports__